export const lohnabrechnungsart = {
  LODAS: 'LODAS',
  LOGE: 'LOGE',
} as const;

export type Lohnabrechnungsart = keyof typeof lohnabrechnungsart;
